import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
import HandleTheIntersection from './utils/HandleTheIntersection';
import HighlightCta from './utils/HighlightCta';
import HighlightAnchorNav from './utils/HighlightAnchorNav';

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();


const lib = {
  'breakpoints': {
      'xs': 0,
      'sm': 640,
      'md': 768,
      'lg': 1024,
      'xl': 1280,
      'xxl': 1536
  },
  qsa: (name, loc = document) => {
    if (loc == "group") {
      return [
        ...document
          .querySelector(name)
          .closest("[data-group]")
          .querySelectorAll(name),
      ];
    }

    return [...loc.querySelectorAll(name)];
  },
  qs: (name, loc = document) => {
    if (loc == "group") {
      return [...document.closest("[data-group]").querySelectorAll(name)];
    }

    return loc.querySelector(name);
  },
}

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function($) {
    Components.init();
    Plugins.init();
    (new HandleTheIntersection).init( /* Name of Viewport Element */); /* Script Adds Classes (For Animation) When That Class is Scrolled To In View */
    (new HighlightAnchorNav).init(); /* Script Highlights The Nav When Reaching an Anchor Point */
    (new HighlightCta).init({  
      /* Name of Anchor */  id: 'highlightcta', 
      /* Applied Outline */ outline: '8px solid #6565ea50' 
    }); /* Script Highlights an Element when its relating anchor is clicked (e.g id="highlightcta" will be highlighted from links with href="#highlightcta") */
});




let previousStep = 1;


const formStatusCheck = () => {
    const button = document.querySelector('#gform_submit_button_2');

    if(button && !button.dataset.isListener) {
        button.dataset.isListener = true;
        button.addEventListener('click', () => {
            dataLayer.push({
                'event': 'conversionForm-Step', 
                'conversionValue': 'Completed Submission'
            });

            // fbq('trackCustom', 'ConversionFormStep', { 
            //     conversionValue: 'Form Step ' + '7'
            // });\\


            // fbq('track', 'Lead' , { 
            //     conversionValue: '1'
            // });

            console.error('event fired: Completed Submission');
        });
    }


    lib.qsa('.--multistep-form').forEach((el) => {
        let hasProgressed = false;

        if(!lib.qs('.gf_step_current_page', el)) {
          return;
        }

        let currentStep = lib.qs('.gf_step_current_page', el).innerHTML;
       
        // Check if CurrentStep is more than
        // Previous Step
        if(currentStep > previousStep) {
            hasProgressed = true;
            previousStep = currentStep;
        }

        //  GTM Configuration
        //  * Trigger Configuration -> Custom Event -> Rejex Matching
        //  * If Rejex Matches then 
        //  * Variable name: conversionForm-Step
        //  * Event name: conversionForm-Step
        //  * This trigger fires on: All Custom Events

        // If hasProgressed is true then
        // Push DataLayer to Tag Manager
        if(hasProgressed) {
            // Tag Manager Data Layer Push
            dataLayer.push(
                {
                    'event': 'conversionForm-Step', 
                    'conversionValue' : 'Form Step ' + currentStep
                }
            );


            // fbq('track', 'Lead' , { 
            //     conversionValue: 'Form Step ' + currentStep 
            // });

            console.error('event fired: Form Step ' + currentStep); // Event Fire Debug
            hasProgressed = false;
        }

  
    })
}

setInterval(formStatusCheck, 200);